import React from "react";
import ReactDOM from "react-dom/client";
// Import axios config FIRST to set withCredentials globally
import "@/config/axios";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
